import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { pageStyles } from "./pageStyles";
import NavBar from "./NavBar";

export default function ForgotPasswordPage() {
  const { requestPasswordReset } = useAuth();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const data = await requestPasswordReset(email);
      setResult(data);
    } catch (err) {
      setError(err.message || "Something went wrong.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={pageStyles.page}>
      <NavBar />
      <div style={pageStyles.authWrap}>
        <form style={pageStyles.card} onSubmit={handleSubmit}>
          <h1 style={pageStyles.title}>Reset your password</h1>
          <p style={pageStyles.subtitle}>
            Enter your account email and we'll email you a link to choose a new password.
          </p>

          <label style={pageStyles.label} htmlFor="forgot-email">Email</label>
          <input
            id="forgot-email"
            type="email"
            required
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={pageStyles.input}
          />

          {error ? <div style={pageStyles.errorBanner}>{error}</div> : null}
          {result ? (
            <div style={result.email_enabled === false ? pageStyles.errorBanner : pageStyles.successBanner}>
              {result.message}
              {result.dev_reset_token ? (
                <>
                  {" "}
                  No email service is configured yet, so here's your reset link directly:{" "}
                  <Link
                    to={`/reset-password?token=${encodeURIComponent(result.dev_reset_token)}`}
                    style={pageStyles.link}
                  >
                    reset your password
                  </Link>
                  .
                </>
              ) : null}
            </div>
          ) : null}

          <button
            type="submit"
            disabled={submitting || (result && result.email_enabled !== false)}
            style={{ ...pageStyles.button, ...(submitting ? pageStyles.buttonDisabled : {}) }}
          >
            {submitting ? "Sending…" : "Send reset link"}
          </button>

          <div style={pageStyles.linkRow}>
            <span />
            <Link to="/login" style={pageStyles.link}>Back to sign in</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
